import React from 'react';
import { Camera, Upload, X, Brain } from 'lucide-react';

interface AIPhotoModeSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onTakePhoto: () => void;
  onUploadPhotos: () => void;
}

export function AIPhotoModeSelector({
  isOpen,
  onClose,
  onTakePhoto,
  onUploadPhotos
}: AIPhotoModeSelectorProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-2">
            <Brain className="w-6 h-6 text-indigo-600" />
            <h2 className="text-xl font-bold text-gray-800">AI Photo Mode</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-gray-600 text-sm text-center mb-6">
            Choose how you want to capture photos for AI analysis
          </p>

          <button
            onClick={() => {
              onTakePhoto();
              onClose();
            }}
            className="w-full bg-indigo-500 hover:bg-indigo-600 text-white p-6 rounded-lg shadow-lg transition-all duration-200 flex flex-col items-center gap-3"
          >
            <Camera className="w-12 h-12" />
            <div>
              <div className="font-bold text-lg">Take Photo Now</div>
              <div className="text-sm text-indigo-100 mt-1">
                Capture a photo right now at your current location
              </div>
            </div>
          </button>

          <button
            onClick={() => {
              onUploadPhotos();
              onClose();
            }}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white p-6 rounded-lg shadow-lg transition-all duration-200 flex flex-col items-center gap-3"
          >
            <Upload className="w-12 h-12" />
            <div>
              <div className="font-bold text-lg">Upload Photos</div>
              <div className="text-sm text-blue-100 mt-1">
                Process existing photos with GPS and timestamp data
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
